export default __webpack_public_path__ + "static/media/kinder8.28ae82b9.jpg";